import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppStore } from "app/_shared/stores/app.store";
import { Permission } from "app/_shared/types/models/role";
import { AppUser } from "app/_shared/types/models/user";
import { environment } from "environments/environment";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  apiUrl: string = environment.api + "auth";

  constructor(
    private http: HttpClient,
    private appStore: AppStore,
  ) {}

  me(email: string) {
    return this.http.post<AppUser & { permissions: Permission[] }>(`${this.apiUrl}/me`, { email }).pipe(
      map((response) => {
        const { permissions, ...user } = response;
        if (user) {
          this.appStore.setState({ user, permissions });
        }
        return user as AppUser;
      }),
    );
  }

  logout() {
    return this.http.post<{ message: string }>(`${this.apiUrl}/logout`, {}).pipe(
      map(() => {
        this.appStore.setState({ user: null, permissions: [] });
        return true;
      }),
    );
  }

  /*avatar() {
      return this.http.get(`https://graph.microsoft.com/v1.0/me/photo/$value`, { responseType: "blob" }).pipe(
        switchMap((blob) => from(blobToBase64(blob))),
        catchError(() => of(null)),
      );
    }*/
}
